import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {AuthenticationService} from "./authentication.service";
import {NzMessageService} from "ng-zorro-antd/message";
import { User } from "src/app/shared/interfaces/user.type";

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private userApiUrl = `${environment.apiUrl}/usuario`
  private profile$ = new BehaviorSubject(null);
  private avatarUrl$ = new BehaviorSubject<string>(null);
  private userContext: User = null;

  get profile() {
    return this.profile$.asObservable()
  }

  set profile(value: any) {
    this.profile$.next(value);
  }

  get avatarUrl() {
    return this.avatarUrl$.asObservable();
  }

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private message: NzMessageService,
  ) {
    this.authService.userContext.subscribe({
      next: (user) => this.userContext = user
    })
  }

  setAvatar() {
    const storedAvatar = sessionStorage.getItem('avatar');
    if (storedAvatar) {
      return this.avatarUrl$.next(storedAvatar)
    }
    this.getAvatar().subscribe({
      next: (res: { avatar: string }) => {
        if (res && res.avatar) {
          sessionStorage.setItem('avatar', res.avatar)
          return this.avatarUrl$.next(res.avatar)
        }
        sessionStorage.removeItem('avatar')
        this.avatarUrl$.next(null)
      },
    })
  }

  getProfile() {
    if (!this.profile$.value) {
      return this.http.get(`${this.userApiUrl}/${this.userContext.id}/perfil`)
    }
    return this.profile$.value;
  }

  getAvatar() {
    return this.http.get(`${this.userApiUrl}/${this.userContext.id}/avatar`)
  }

  updateProfile(profileFormValue: any) {
    return this.http.patch(`${this.userApiUrl}/${this.userContext.id}/atualizar-perfil`, profileFormValue)
  }

  updatePassword(updatePassFormValue: any) {
    return this.http.patch(`${this.userApiUrl}/${this.userContext.id}/atualizar-senha`, updatePassFormValue)
  }

  updateAvatar(avatarFormValue: any) {
    return this.http.patch(`${this.userApiUrl}/${this.userContext.id}/atualizar-avatar`, avatarFormValue)
  }

  removeAvatar() {
    return this.http.delete(`${this.userApiUrl}/${this.userContext.id}/avatar`)
  }

}
